import { Model } from '@/models/Model';
export class Presence extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Presence';
        this.$endpoint = '/v1/events/{id}/relationships/presence';
        this.$fillable = ['status'];
    }
    event(event) {
        this.$endpoint = `/events/${event.id}/relationships/presence`;
        return this;
    }
    setIdAttribute(id) {
        this.$endpoint = `/events/${this.event}/relationships/presence`;
        return id;
    }
    resolvePrimaryKey() {
        return '';
    }
}
